module.exports = __webpack_public_path__ + "static/media/live18_09_2018.b921d592.jpg";